import { FC } from 'react'

import { FF, FormType, RadioGroup, Select } from 'ui/components'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { QuestionnaireDemo } from '../../../../../../types'
import * as SC from '../../../../style'

export const InternalTransfers: FC<{ formApi: FormType<QuestionnaireDemo> }> = ({ formApi }) => {
  return (
    <>
      <FormRow>
        <Col2x>
          <SC.MainText>
            A Tier III review is conducted annually on personal accounts belonging to owner(s) or manager(s) for EDD. If
            excessive commingling of funds is found during the review, a SAR will be filed accordingly, and management
            will be notified.
          </SC.MainText>
        </Col2x>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            Review the Quarterly High Risk Review Analytics for internal transfers and research the offsetting account.
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="internalTransfersReview"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name="internalTransfersPurpose"
            children={(field) => (
              <FF
                field={field}
                label="Purpose of the transfer(s) for business account?"
                input={(p) => (
                  <Select
                    data={[
                      {
                        label: 'No Transactions of This Type',
                        value: 'no_transactions'
                      },
                      {
                        label: 'Transfer for Tax Purposes',
                        value: 'tax_purposes'
                      },
                      {
                        label: 'Transfer for Product Purchases',
                        value: 'product_purchases'
                      },
                      {
                        label: 'Transfer for Loan Payment',
                        value: 'loan_payment'
                      },
                      {
                        label: 'Transfer for Contribution/Distribution',
                        value: 'contribution_distribution'
                      },
                      {
                        label: 'Transfer for Credit Card Payments',
                        value: 'card_payments'
                      },
                      {
                        label: 'Unsure of Transfer Purpose – See Quarterly and/or Annual Review Questions',
                        value: 'see_quarterly'
                      },
                      {
                        label: 'Other – See Comments',
                        value: 'other'
                      }
                    ]}
                    {...p}
                  />
                )}
              />
            )}
          />
        </Col>
      </FormRow>
    </>
  )
}
